<header-title [model]="headerTitle"></header-title>

<section class="card mt-4">
    <header class="card-header">
        <div class="card-header-icon">
            <i class="fas fa-tasks"></i>
        </div>
        <h3>{{companyDetailsModel?.legalName}} - Audit Templates</h3>
    </header>
    <div class="card-body py-5">
        <div class="container">
            <div class="tab-navigation">
                <nav>
                    <ul class="nav nav-pills">
                        <li class="">
                            <a class="nav-link" [routerLink]="['/company', companyId]">
                                <i class="fas fa-building" aria-hidden="true"></i>Company Details
                            </a>
                        </li>
                        <li class="">
                            <a class="nav-link" [routerLink]="['/company', 'users', companyId]">
                                <i class="fas fa-users" aria-hidden="true"></i>Company Users
                            </a>
                        </li>
                        <li class="nav-active">
                            <a class="nav-link">
                                <i class="fas fa-tasks" aria-hidden="true"></i>Company Audits
                            </a>
                        </li>
                        <li class="">
                            <a class="nav-link" [routerLink]="['/company', 'lenders', companyId]">
                                <i class="fas fa-dollar-sign" aria-hidden="true"></i>Company Lenders
                            </a>
                        </li>
                        <li class="">
                            <a class="nav-link" [routerLink]="['/company', 'audit-targets', companyId]">
                                <i class="fas fa-bullseye" aria-hidden="true"></i>Audit Targets
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>

            <section class="card">
                <div class="card-body">
                    <error-message [errors]="errors"></error-message>
                    <div class="row mt-3">
                        <div class="col-12">
                            <button *ngIf="!isAddMode" class="btn btn-primary" type="button" (click)="toggleAddMode()">Add Audit Template</button>
                            <button *ngIf="isAddMode" class="btn btn-warning" type="button" (click)="toggleAddMode()">Cancel</button>
                        </div>
                    </div>
                    <div class="row mt-3" *ngIf="!isAddMode">
                        <div class="col-12">
                            <app-company-audit-templates-list [companyId]="companyId"></app-company-audit-templates-list>
                        </div>
                    </div>
                    <div class="row mt-3" *ngIf="isAddMode">
                        <div class="col-12">
                            <app-company-audit-template-add [companyId]="companyId" (auditTemplateAdded)="auditTemplateAdded($event);"></app-company-audit-template-add>
                        </div>
                    </div>
                </div>
            </section>
        </div>

    </div>
</section>
